import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { salaryDeviationSubmitted } from "store/actions/salaryDeviationsActions";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { SalaryDeviationFooterProps } from "models/propTypes/salaryDeviationPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import { useSalaryDeviationsService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SalaryDeviationFooter: React.FC<SalaryDeviationFooterProps> = (props) => {
  const salaryDeviationsService = useSalaryDeviationsService();
  const { salaryDeviationReport, markAsDoneHandler, disableSuccessMessages } = props;
  const dispatch = useDispatch();

  const onAcceptSuccess = () => {
    markAsDoneHandler && markAsDoneHandler();
    dispatch(salaryDeviationSubmitted(salaryDeviationReport.id));
  };

  const onSalaryDeviationReportAccept = () => {
    return salaryDeviationsService.submitReport(salaryDeviationReport.yearMonth);
  };

  return (
    <PageFooter
      actions={[
        {
          text:
            props.overrideApproveButtonText ??
            LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Approve),
          onClick: onSalaryDeviationReportAccept,
          type: StyleEnums.DisplayType.Success,
          successMessage: LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.SalaryDeviation.SubmitSuccessMessage
          ),
          onActionSuccess: onAcceptSuccess,
        },
      ]}
      className={props.className}
      disableSuccessMessages={disableSuccessMessages}
    />
  );
};

export default SalaryDeviationFooter;
